export default __webpack_public_path__ + "static/media/shutterstock_793500085.7c71a03e.png";